// Internal modules
import { appStore } from '@/store';
import { hasOwnProp } from '@checkout/react-components';
import {
  containsRightOfWithdrawalCheckbox,
  features,
  focusOnFirstError,
  getFieldError,
} from '@/lib';

const validateForm = state => {
  const accum = { errorLogPayload: {}, formErrors: {} };

  return Object.keys(state).reduce((errors, field) => {
    const fieldState = state[field];
    if (hasOwnProp(fieldState, 'isValid') && !fieldState.isValid) {
      const { errorCode, isValid, value } = fieldState;
      errors.formErrors[field] = {
        displayError: true,
        error: getFieldError({ errorCode, field, isValid, value }),
      };
      errors.errorLogPayload[field] = fieldState.errorCode;
    }
    return errors;
  }, accum);
};

const filterFormState = state => {
  const isPasswordlessUpgrade = features.isActive('isPasswordlessUpgrade');
  const { onboardOption, password, signupAgreeToTerms, marketingOptIn } = state;
  // adding the kyc fields
  const kycFieldsFromForm = {};
  const kycFields = features.config.kycFields;

  kycFields.forEach(field => {
    const formattedField = field[0].toLowerCase() + field.substring(1);
    kycFieldsFromForm[formattedField] = state[formattedField];
  });

  const formState = {
    marketingOptIn,
    onboardOption,
    password,
    signupAgreeToTerms,
    ...kycFieldsFromForm,
  };

  if (isPasswordlessUpgrade) {
    // Bypass password form validation,
    delete formState?.password;
  }

  if (containsRightOfWithdrawalCheckbox(onboardOption.value)) {
    formState.rightOfWithdrawal = state.rightOfWithdrawal;
  }

  return formState;
};

const displayFormErrors = (fieldsWithErrors, formErrors) => {
  const { form: formActions } = appStore.getActions();
  fieldsWithErrors.forEach(([field, payload]) => {
    const fieldName = 'field';
    const action = 'updateNonAddressField';

    formActions[action]({
      [fieldName]: field,
      payload,
    });
  });

  focusOnFirstError(formErrors);
};

export { displayFormErrors, filterFormState, validateForm };
